import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import Slide from '@material-ui/core/Slide';

import loader from 'assets/img/loader.gif';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';

import CardHeader from 'components/Card/CardHeader.jsx';

import Style from 'assets/jss/material-dashboard-pro-react/views/actionsStyle';

import SolicitationDialog from '../Components/SolicitationDialog.jsx';
import { openSolicitationDialog } from '../../store/actions/navigationActions.jsx';
import config from 'config';

// import { startSetLawyersList } from 'store/actions/lawyersActions';

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

class ExploreMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      assignActionModal: false,
      volUID: '',
      username: '',
    };
  }

  handleClickOpen = (modal, volUID) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      volUID,
    });
  };

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  usersData = () => {
    return this.props.users.dataRows.map((prop, key) => {
      let colObj = { ...prop };
      const volUID = colObj.volUID;
      const username = colObj.username;
      // Load Data for Summary Cards and add buttons
      return {
        ...colObj,
        // status: (<span style={{ color: "red" }}>assigned</span>),
        id: key,
        actions: (
          <Button
            color="primary"
            fullWidth
            onClick={() => this.handleClickOpen('assignActionModal', volUID)}
          >
            ASSIGN ACTION
          </Button>
        ),
      };
    });
  };

  static compareIgnoreCase(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return a.toLowerCase().includes(b.toLowerCase());
  }

  lawyersData = (clients) => {
    let { query, users, userType } = this.props;
    query = query == '' ? undefined : query;
    return users.dataRows.filter(function (user) {
      return (
        user.userType.toLowerCase() == userType &&
        (ExploreMap.compareIgnoreCase(user.firstName, query) ||
          ExploreMap.compareIgnoreCase(user.lastName, query) ||
          ExploreMap.compareIgnoreCase(user.volUID, query)) &&
        (user.userType.toLowerCase() == 'client' ? clients.includes(user.uid) : true)
      );
    });
  };

  //   loadLawyers = () => {
  //     startSetLawyersList();
  //     this.setState({
  //       lawyersLoaded: true,
  //     });
  //   };

  handleChange = (docID) => {
    console.log(docID);
  };

  render() {
    const {
      AuthBool,
      classes,
      query,
      cases,
      loading,
      solicitationDialogOpen,
      openSolicitationDialog,
      cancelSolicitationDialog,
      continueSolicitationDialog,
    } = this.props;

    const searchButton = classes.top + ' ' + classes.searchButton;

    // if (!this.state.lawyersLoaded) {
    //   this.loadLawyers();
    // }
    // if(cases) {this.filterData(query, cases.dataRows)}
    let clients = [];

    if (this.props.userType == 'client') {
      cases.dataRows.map((cases) => {
        clients.push(cases.client);
      });

      //   console.log(clients);
    }
    // console.log(this.lawyersData());
    return (
      <div>
        <SolicitationDialog />
        {!loading ? (
          <div>
            {this.lawyersData(clients).map((lawyerRow) => {
              return (
                <div key={lawyerRow.uid}>
                  <Card>
                    <CardHeader>
                      <GridContainer>
                        <GridItem xs={3}>
                          <img
                            src={
                              lawyerRow.profileURL ||
                              'https://firebasestorage.googleapis.com/v0/b/golegalese.appspot.com/o/default-avatar.png?alt=media&token=1402931b-2c70-4833-80ce-7a877a8b501b'
                            }
                            style={{
                              borderRadius: '50%',
                              height: '65px',
                              marginTop: '10px',
                            }}
                            alt="..."
                          />
                        </GridItem>
                        <GridItem xs={9}>
                          <h5 style={{ color: 'black', fontSize: '.9rem' }}>
                            <b>
                              {lawyerRow.firstName} {lawyerRow.lastName}
                            </b>{' '}
                            <br />
                            Bar #{lawyerRow.barNumber} | {lawyerRow.city},{' '}
                            {lawyerRow.state}
                            <br />
                            Experience Level: {lawyerRow.experience} years
                          </h5>
                        </GridItem>
                      </GridContainer>
                      <hr />
                      <p
                        style={{
                          color: '#FC6047',
                          fontSize: '.9rem',
                          fontWeight: '900',
                        }}
                      >
                        Specializes in:
                      </p>

                      <p
                        style={{
                          color: '#FC6047',
                          fontSize: '.9rem',
                          fontWeight: '900',
                        }}
                      >
                        Services:
                      </p>
                      <GridContainer>
                        <GridItem xs={5}>
                          <Link
                            to={{
                              pathname: `/lawyer/${lawyerRow.uid}`,
                              state: { dataLoaded: false },
                            }}
                          >
                            <Button
                              color="primary"
                              style={{
                                backgroundColor: '#3f51b5',
                                marginLeft: '10px',
                                marginBottom: '10px',
                              }}
                            >
                              <b>View Profile</b>
                            </Button>
                          </Link>
                        </GridItem>
                        <GridItem xs={5}>
                          {/*
                                                            <Link to={{
                                                                pathname: `/threads/${lawyerRow.id}`,
                                                                state: { dataLoaded: false }
                                                            }}>
                                                            */}
                          <Button
                            color="primary"
                            style={{
                              backgroundColor: 'rgb(14, 178, 216)',
                              marginLeft: '10px',
                              marginBottom: '10px',
                            }}
                            onClick={openSolicitationDialog}
                          >
                            <b>Send Message</b>
                          </Button>
                          {/*</Link>*/}
                        </GridItem>
                      </GridContainer>

                      {/*<br/><small> Listed {moment(caseRow.createdDate.toDate()).format('MM-DD-YYYY')}</small>*/}
                    </CardHeader>

                    {/*<CardBody>
                                           <Link to={{
                    pathname: `/case/${caseRow.id}`,
                    state: { dataLoaded: false }
                  }}>

                        <p ><span style={{color: "black"}}>Case Type:</span> <span style={{fontWeight: "900", color:"rgb(14, 178, 216)"}}>{caseRow.caseType}</span> </p>
                        <p><span style={{color: "black"}}>Service Needed:</span>  <span style={{fontWeight: "900", color:"rgb(14, 178, 216)"}}>{caseRow.serviceNeeded}</span></p>
                                             </Link>

                      <Accordion
                        active={1}
                        collapses={[
                          {
                            title: "Summary",
                            content:
                             caseRow.summary
                          }
                        ]}
                      />
                    </CardBody>*/}
                  </Card>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#F7F4F0',
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <img
              style={{ margin: '65% 0% 0% 41%', position: 'relative', width: '20%' }}
              src={loader}
              alt="..."
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authUser: state.auth.user,
    user: state.user.user,
    users: state.user.users,
    cases: state.cases.cases,
    solicitationDialogOpen: state.navigation.solicitationDialogOpen,
    loading: false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openSolicitationDialog: () =>
      dispatch(openSolicitationDialog(config.solicitationWarningThread)), // TODO: add continue action
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(ExploreMap);
